export function drawerMenu() {
  document.querySelectorAll('.c-button__nav-switch').forEach((menuButton) => {
    menuButton.addEventListener('click', switchMenu);
    function switchMenu() {
      const navDrawer = document.querySelector('#nav-drawer');
      navDrawer.classList.toggle('is-drawerActive');
      const navListItem = document.querySelectorAll('ul > li');
      navListItem.forEach((navActiveListItem, index) => {
        setTimeout(() => {
          navActiveListItem.classList.toggle('is-active__nav');
        }, 100 * index);
      });
    }
  });
}
